import FiscalYearType from '../../../enums/fiscalYearType';
import { getActiveCompanyRole, getDefaultAppointeeModel } from '../shared/models';
export const getDefaultCreateCompanyFormModel = () => ({
    clientName: null,
    fiscalIdentifier: '',
    activityCode: '',
    companyName: '',
    address: '',
    phoneNumber: '',
    faxNumber: '',
    email: '',
    taxType: null,
    isBank: null,
    role: null,
    hasAppointee: null,
    appointee: null,
    signer: null,
    fiscalYearType: FiscalYearType.Calendar,
    fiscalYear: null
});
export const getDefaultEditCompanyFormModel = () => ({
    clientName: null,
    fiscalIdentifier: '',
    activityCode: '',
    companyName: '',
    address: '',
    phoneNumber: '',
    faxNumber: '',
    email: '',
    taxType: null,
    isBank: null,
    role: null,
    hasAppointee: null,
    appointee: null,
    signer: null,
    fiscalYearType: null,
    fiscalYear: null
});
export const getEditCompanyFormModelFromCompanyDetails = (companyDetails) => ({
    clientName: companyDetails.clientDetails.clientName,
    fiscalIdentifier: companyDetails.fiscalIdentifier,
    activityCode: companyDetails.activityCode,
    companyName: companyDetails.name,
    address: companyDetails.address,
    phoneNumber: companyDetails.phoneNumber || '',
    faxNumber: companyDetails.faxNumber || '',
    email: companyDetails.email || '',
    taxType: companyDetails.taxType,
    isBank: companyDetails.isBank,
    role: getActiveCompanyRole(companyDetails.roles),
    hasAppointee: companyDetails.appointee !== null,
    appointee: companyDetails.appointee || getDefaultAppointeeModel(),
    signer: companyDetails.signer,
    fiscalYearType: companyDetails.fiscalYearType,
    fiscalYear: companyDetails.fiscalYear
});
export const getSavedCompanyModelFromCompanyFormModel = (companyFormModel, getRoles) => ({
    clientName: companyFormModel.clientName,
    fiscalIdentifier: companyFormModel.fiscalIdentifier,
    activityCode: companyFormModel.activityCode,
    companyName: companyFormModel.companyName,
    address: companyFormModel.address,
    phoneNumber: companyFormModel.phoneNumber,
    faxNumber: companyFormModel.faxNumber,
    email: companyFormModel.email,
    taxType: companyFormModel.taxType,
    isBank: companyFormModel.isBank,
    roles: getRoles(companyFormModel.role),
    appointee: companyFormModel.hasAppointee ? companyFormModel.appointee : null,
    signer: companyFormModel.signer,
    fiscalYearType: companyFormModel.fiscalYearType,
    fiscalYear: companyFormModel.fiscalYear
});
export const getDefaultCompaniesFilterFormModelState = () => ({
    status: []
});
